export default __webpack_public_path__ + "static/bg-cs-zappi--mobile-3304a505235f45213f9c7dce9418a294.jpg";